import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  session: null,
  isAuthenticated: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    setSession(state, action) {
      state.session = action.payload;
      if (action.payload) {
        state.isAuthenticated = true;
        console.log("inauthslice", state.isAuthenticated);
      }
    },
    logout(state) {
      state.user = null;
      state.session = null;
      state.isAuthenticated = false;
      localStorage.removeItem("user");
      localStorage.removeItem("session");
    },
  },
});

export const { setUser, setSession, logout } = userSlice.actions;

export default userSlice.reducer;
